import { render } from "./Obras.vue?vue&type=template&id=ae6f3c84&scoped=true"
import script from "./Obras.vue?vue&type=script&lang=js"
export * from "./Obras.vue?vue&type=script&lang=js"

import "./Obras.vue?vue&type=style&index=0&id=ae6f3c84&lang=scss&scoped=true"

import exportComponent from "C:\\Dev\\Vue\\intensione\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6f3c84"]])

export default __exports__